import { isNil } from "lodash";
import { UrlObject } from "url";

export const encodeQueryParams = (params: any) => {
    try {
        if (isNil(params)) {
            throw new Error(
                "The 'params' argument is undefined or null and cannot be encoded."
            );
        }

        const paramsString = JSON.stringify(params);
        return encodeURI(paramsString);
    } catch (e) {
        console.error(e);
        return null;
    }
};

export const decodeQueryParams = (params: string) => {
    try {
        return JSON.parse(decodeURI(params));
    } catch (e) {
        console.error(e);
        return null;
    }
};

export const getPathname = (link?: string | UrlObject) =>
    typeof link === "string" ? link : link?.pathname;
